import React from "react";
import { useDispatch } from "react-redux";

import { IgButton } from "@intelligems/ig-theme";
import { AnyProgressBarWidget } from "@intelligems/ig-types";
import { Grid } from "@mui/material";

import { initializeWidget } from "../../../api/initials";
import { setDrawer } from "../../../store/slices/global";
import { setSelectedWidget } from "../../../store/slices/widgets";
import { mpClickCreateWidgetButton } from "../../../utils/mixpanel";
import { WidgetDrawer } from "../WidgetDrawer/WidgetDrawer";

import { DiscountProgressBarWidgetPreview } from "./DiscountProgressBarWidgetPreview";

interface ProgressBarWidgetsOverviewProps {
  progressBarWidgets: AnyProgressBarWidget[];
}
export const DiscountProgressBarWidgetsOverview = ({
  progressBarWidgets,
}: ProgressBarWidgetsOverviewProps) => {
  const dispatch = useDispatch();

  const onCreateNew = () => {
    mpClickCreateWidgetButton("discountProgressBar");
    dispatch(
      setSelectedWidget(
        initializeWidget(
          "discountProgressBar",
          "progressBarWidget1"
        ) as AnyProgressBarWidget
      )
    );
    dispatch(setDrawer({ drawer: "widgetAction", open: true }));
  };

  return (
    <Grid
      container
      direction={"column"}
      alignItems={"flex-end"}
      rowSpacing={2}
      columnSpacing={2}
    >
      <Grid item>
        <IgButton
          variant={"contained"}
          onClick={() => {
            onCreateNew();
          }}
        >
          Create Progress Bar
        </IgButton>
      </Grid>
      <Grid item container direction={"row"} rowSpacing={2} columnSpacing={2}>
        {progressBarWidgets.map((progressBar, index) => (
          <DiscountProgressBarWidgetPreview
            key={`progress-bar-${index}`}
            progressBarWidget={progressBar}
          />
        ))}
        <WidgetDrawer
          widgetType={"discountProgressBar"}
          buttonFocus={"discountProgressBar"}
        />
      </Grid>
    </Grid>
  );
};
